module.exports = __webpack_public_path__ + "resources/img/img_mazebolt1.3007ae190d28ce940daadc6aa2006dd8.png";